import Vue from 'vue'
import Router from 'vue-router'
import {sesStorage} from '../utils/storage'
Vue.use(Router)

const Routers = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/login'　　//默认显示
    },
    {
      path: '/',
      component: () => import('../components/layout'),
      redirect: '/',
      children: [
        {
          path: 'login',
          name: 'login',
          component: () => import('../view/login/login'),
        },
        {
          path: 'password',
          name: 'password',
          component: () => import('../view/password/password'),
        },
        {
          path: 'home',
          name: 'home',
          component: () => import('../view/home/home'),
        },
        {
          path: 'details',
          name: 'detail',
          component: () => import('../view/details/detail'),
        },
        {
          path: 'order',
          name: 'order',
          component: () => import('../view/order/order'),
        },
      ]
    },
    {
      path: '/privacy-policy.html',
      component: () => import('../view/login/privacy'),
      hidden: true
    },
    {
      path: '/terms-of-us.html',
      component: () => import('../view/login/terms'),
      hidden: true
    },
  ]
})

const whiteList = ['/home', '/login', '/password', '/privacy-policy.html', '/terms-of-us.html']
const mustLoginList = ['/order', '/details']
Routers.beforeEach((to, from, next) => {
  const hasToken = sesStorage.get('token')
  if (hasToken) {
    next()
  } else {
    if (whiteList.includes(to.path)) {
      next()
    } else {
      next('/home')
    }
  }
})
Routers.afterEach(() => {
  scrollToTop()
})


const scrollToTop = () => {
  let sTop = document.documentElement.scrollTop || document.body.scrollTop
  if (sTop > 0) {
      window.requestAnimationFrame(scrollToTop)
      window.scrollTo(0, sTop - sTop / 8)
  }
}

export default Routers
